<template>
    <div v-if="providerInfo">
        <v-container grid-list-xs>
            <v-row>
                <v-col>
                    <v-sheet class="pa-5" elevation="3">
                        <h4 class="mb-2 primary--text">{{ $t("results.congratulations") }}</h4>

                        <p class="mb-5">
                            {{
                                $t("results.approval-message", {
                                    providerName: providerInfo.name,
                                    approvalAmount: formattedApprovedAmount,
                                    today: formattedTodaysDate,
                                })
                            }}
                        </p>

                        <h4 class="body-1-lg mb-2 primary--text">{{ $t("results.list-title") }}</h4>

                        <ul class="body-1 bullet-styles">
                            <li v-for="item in $t('results.approved.beforeYouLeave')">
                                {{ item }}
                            </li>

                            <li v-for="item in $t('results.approved.beforeYouLeaveNoEmail')" v-if="!termsEmailed">
                                {{ item }}
                            </li>
                        </ul>

                        <h4 class="body-1-lg mb-2 primary--text">
                            {{
                                $t("results.approved.patient-financing-promise-title", {
                                    providerName: providerInfo.name,
                                })
                            }}
                        </h4>
                        <p class="mb-5">
                            {{
                                $t("results.approved.patient-financing-promise-body", {
                                    providerName: providerInfo.name,
                                })
                            }}
                        </p>
                        <v-row justify="center">
                            <v-col class="d-flex justify-end mt-6">
                                <SubmitButton class="secondary" rounded @click="finish">
                                    {{ $t("action.finish") }}
                                </SubmitButton>
                            </v-col>
                        </v-row>
                        <ResponsiveImage :image-url="footerLogo" width="100px" class="footer-logo-center" />
                    </v-sheet>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { applicationState, providerState, sessionState } from "@/state"
    import { formatCurrency } from "@/util/currency"
    import Providers from "@/model/provider/Providers"
    import { formatDate } from "@/util/date"
    import AutoFinishMixin from "@/components/apply/AutoFinishMixin"
    import ProviderState from "@/state/ProviderState"
    import ProviderKey from "@/model/provider/ProviderKey"

    export default {
        mixins: [AutoFinishMixin],
        data() {
            return {
                providerInfo: Providers[sessionState.dynamicProviderKey.providerKey],
            }
        },
        computed: {
            formattedTodaysDate() {
                return formatDate(new Date())
            },
            termsEmailed() {
                return !!applicationState.application?.primary?.email
            },
            formattedApprovedAmount() {
                return formatCurrency(providerState.getApplyResponse(this.providerKey)?.approvedAmountCents)
            },
            footerLogo() {
                const response = ProviderState.getPreAuthResponse()
                return response
                    ? Providers[ProviderKey.HFD_STANDARD]?.footerLogo[response.providerProductName]
                    : undefined
            },
        },
    }
</script>
